// extracted by mini-css-extract-plugin
module.exports = {"Details":"styles_Details__3HxB2","preview":"styles_preview__FJTlo","previewBox":"styles_previewBox__15OGS","previewBoxMobile":"styles_previewBoxMobile__31AW8"};